import { getUserConfiguration } from 'owa-session-store';
import {
    setShowPreviewLinesOptionMutator,
    selectTempPreviewLinesOptionMutator,
} from '../actions/selectMessageListLayoutOption';
import getShowPreviewLinesInListViewOCSSetting from './getShowPreviewLinesInListViewOCSSetting';
import { isSingleLineListView } from 'owa-mail-layout';
import messageListLayoutStore from '../store/messageListLayoutStore';

let loadShowPreviewLinesInListView: Promise<void> | undefined;
export default function initializeShowPreviewLinesInListViewSetting(): Promise<void> {
    const messagePreviewStore = messageListLayoutStore();
    if (messagePreviewStore.showPreviewLinesInListView !== null) {
        if (messagePreviewStore.tempPreviewLinesInListView === null) {
            Promise.resolve().then(() => {
                if (messagePreviewStore.tempPreviewLinesInListView === null) {
                    selectTempPreviewLinesOptionMutator(
                        messagePreviewStore.showPreviewLinesInListView
                    );
                }
            });
        }
        return Promise.resolve();
    }

    if (!loadShowPreviewLinesInListView) {
        loadShowPreviewLinesInListView = (async () => {
            const showPreviewLinesOption = await getShowPreviewLinesInListViewOCSSetting();
            if (showPreviewLinesOption === null) {
                setShowPreviewLinesOptionMutator(convertPreviewTextFlagToNumber());
            } else {
                setShowPreviewLinesOptionMutator(showPreviewLinesOption);
            }

            if (messagePreviewStore.tempPreviewLinesInListView === null) {
                selectTempPreviewLinesOptionMutator(messagePreviewStore.showPreviewLinesInListView);
            }
        })().finally(() => {
            loadShowPreviewLinesInListView = undefined;
        });
    }
    return loadShowPreviewLinesInListView;
}

function convertPreviewTextFlagToNumber(): number {
    const userConfig = getUserConfiguration();
    const previewTextToNumber = userConfig?.UserOptions?.ShowPreviewTextInListView ? 1 : 0;
    // convert for MCL and SCL
    return isSingleLineListView() && previewTextToNumber === 1 ? 0 : previewTextToNumber;
}
